import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class HelpService {
  constructor() {}
  hasValue(obj: any): boolean {
    return obj !== null && obj !== undefined && Object.keys(obj).length > 0;
  }

  checkTcNumber(tcNumber: string) {
    const tcRegex = /^[1-9]\d{10}$/; // 11 haneli ve ilk haneleri 0 olamaz
    const firstCheck = tcRegex.test(tcNumber);
    if (!firstCheck) {
      return false;
    }
    return true;
  }

  loadScript(scriptUrl: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.onload = () => {
        // İstersen burada bazı özel işlemler yapabilirsin
        if (typeof (window as any)['myExternalFunction'] === 'function') {
          (window as any)['myExternalFunction']();
        }
        resolve(); // ✅ Script başarıyla yüklendi
      };
      script.onerror = () => {
        reject(`Script yüklenemedi: ${scriptUrl}`);
      };
      document.body.appendChild(script);
    });
  }

  //bu custom validator sadece tarih kısmını kontrol ediyor
  checkDate(control: AbstractControl): ValidationErrors | null {
    const inputDate = new Date(control.value);
    const today = new Date();

    // Sadece tarih kısmını karşılaştirmak için saatleri sıfırladim
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return inputDate < today ? { dateInPast: true } : null;
  }
  calculateDate_Age(birthDate: Date): number {
    if (!birthDate) return 0;

    const date = new Date(birthDate); // 👈 string -> Date
    if (isNaN(date.getTime())) return 0; // geçersiz tarih kontrolü

    const today = new Date();
    let age = today.getFullYear() - date.getFullYear();
    const m = today.getMonth() - date.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
      age--;
    }

    return age;
  }
  calculateAge(birthDate: string | Date): number {
    let birth: Date;

    if (birthDate instanceof Date) {
      birth = birthDate;

    } else if (typeof birthDate === 'string') {
      const parsed = new Date(birthDate);

      if (!isNaN(parsed.getTime())) {
        birth = parsed;

      } else {
        const normalized = this.normalizeOcrDate(birthDate);

        if (!normalized) return 0;
        birth = normalized;
      }

    } else {
      return 0;
    }

    const currentDateTime  = new Date();
    console.log('currentDateTime: ->', currentDateTime )

    // Doğumdan bugüne geçen süreyi milisaniye olarak al
    const ageInMilliseconds  = currentDateTime.getTime() - birth.getTime();

    // Milisaniyeyi yıla çevir (365.25 → artık yıllar dahil)
    const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);

    return Math.floor(ageInYears);
  }



  normalizeOcrDate(ocrDate: string): Date | null {
    if (!ocrDate || typeof ocrDate !== 'string') return null;

    // Eğer 6 haneli tarihse: "YYMMDD"
    if (/^\d{6}$/.test(ocrDate)) {
      const year = parseInt(ocrDate.substring(0, 2), 10);
      const month = parseInt(ocrDate.substring(2, 4), 10);
      const day = parseInt(ocrDate.substring(4, 6), 10);

      // 2000 yılından sonrası mı, 1900 mü? Tahmine dayalı:
      const fullYear = year >= 50 ? 1900 + year : 2000 + year;

      return new Date(fullYear, month - 1, day);
    }

    // Eğer 5 haneli tarihse: "YYMDD" gibi bir şey olabilir
    if (/^\d{5}$/.test(ocrDate)) {
      // Mesela "11128" → "2011-12-08"
      const year = parseInt(ocrDate.substring(0, 2), 10);
      const month = parseInt(ocrDate.substring(2, 3), 10);
      const day = parseInt(ocrDate.substring(3, 5), 10);
      const fullYear = year >= 50 ? 1900 + year : 2000 + year;
      return new Date(fullYear, month - 1, day);
    }

    return null; // Anlamlı değilse
  }

  formatYYMMDDToAngularDate(yyMMdd: string, isBirthDate = false): string {
    const currentYear = new Date().getFullYear().toString().slice(2, 4);
    const responseYear = yyMMdd.slice(0, 2);
    let year = '';
    if (isBirthDate) {
      if (responseYear > currentYear) {
        year = '19' + responseYear;
      } else {
        year = '20' + responseYear;
      }
    } else {
      year = '20' + responseYear;
    }
    const month = yyMMdd.slice(2, 4);
    const day = yyMMdd.slice(4, 6);
    return `${year}-${month}-${day}`;
  }

  formatMrz(text: string): string {
    text.replace(/\n/g, '');
    text.replace(' ', '');
    text.replace('<br>', '');
    const half = Math.ceil(text.length / 2);
    const firstLine = text.slice(0, half);
    const secondLine = text.slice(half);
    return `${firstLine}${secondLine}`;
  }

  convertBayets(bytes: number): string {
    // check if bytes is less than 1MB
    const mb = bytes / (1024 * 1024);
    if (mb < 1) {
      const kb = bytes / 1024;
      return kb.toFixed(2).substring(0, 7) + ' KB';
    } else {
      return mb.toFixed(2).substring(0, 7) + ' MB';
    }
  }
}
